import React from 'react';
import Link from '@amzn/meridian/link';
import { useHistory } from 'react-router-dom';
import { PackageType } from '../../api';
import { rootPath } from '../routes';
import { ConfigurationColumnDefinitionFiltersFields } from './ConfigurationColumnDefinitions';

export type ConfigurationSearchLinkProps = {
  packageType: PackageType;
  filter: ConfigurationColumnDefinitionFiltersFields;
  query: string;
};

const ConfigurationSearchLink = ({
  packageType,
  filter,
  query,
}: ConfigurationSearchLinkProps): JSX.Element => {
  const history = useHistory();
  return (
    <Link
      onClick={history.push}
      href={
        packageType === 'test'
          ? `${rootPath}/packages?${filter}=${query}`
          : `${rootPath}/${packageType}s?${filter}=${query}`
      }
    >
      {query}
    </Link>
  );
};

export default ConfigurationSearchLink;
